import { Actions } from "./actions";
import { State } from "./state";
import { fromServer } from "../filters";
import initial from "./state.initial";
// import { Utils } from "../../../utils";
import { ReducerActions, createReducerActions } from "../../../Store/reducer";

type TActions =
  | Actions.GetRequest
  | Actions.PostRequest
  | Actions.GetResponse
  | Actions.PostResponse
  | Actions.Edit
  | Actions.AlertSet
  | Actions.AlertClr
  | Actions.AlertCancel;

const actions: ReducerActions<State.Props, TActions> = {
  [Actions.REQUEST_GET]: getRequest,
  [Actions.REQUEST_POST]: postRequest,
  [Actions.RESPONSE_GET]: getResponse,
  [Actions.RESPONSE_POST]: postResponse,
  [Actions.EDIT]: edit,
  [Actions.ALERT_SET]: alertSet,
  [Actions.ALERT_CLR]: alertClr,
  [Actions.ALERT_CANCEL]: alertCancel
};

export default createReducerActions(actions, initial);
function getRequest(state: State.Props): State.Props {
  return { ...state, loadingGet: true };
}

function getResponse(
  state: State.Props,
  action: Actions.GetResponse
): State.Props {
  // TODO investigate why
  if (!action.data.alerts) return { ...state };

  // Calculate the difference between alerts we know about and new alerts.
  // (Ignore the first read aka count < 0)
  action.diff =
    state.data.count > 0 ? action.data.alerts.count - state.data.count : 0;
  // If diff then we have new alerts so increment pending.
  const pending = action.diff;
  // Load all the alerts into our state.
  const recent = action.data.alerts.recent.map(a => fromServer(a));
  // Merge new state
  const data: State.Data = Object.assign({}, state.data, {
    recent: recent,
    count: action.data.alerts.count
  });
  return {
    ...state,
    status: "OK",
    data: Object.assign({}, data),
    form: Object.assign({}, data),
    submitRequired: false,
    loadingGet: false,
    pending: pending
  };
}

function postRequest(state: State.Props): State.Props {
  return { ...state, loadingPost: true };
}

function postResponse(state: State.Props): State.Props {
  return { ...state, loadingPost: false };
}

function edit(state: State.Props): State.Props {
  return { ...state };
}

function alertSet(state: State.Props, action: Actions.AlertSet): State.Props {
  return { ...state, alert: fromServer(action.data) };
}

function alertClr(state: State.Props): State.Props {
  let pending = state.pending > 0 ? state.pending - 1 : 0;
  return { ...state, pending, alert: undefined };
}

function alertCancel(state: State.Props): State.Props {
  let data = { count: -1, recent: state.data.recent };
  return { ...state, pending: 0, data: Object.assign({}, data) };
}
